
define('template!threadsThreadMessageView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="message-header">\n    <div class="message-sender">\n        <span class="sender-name">' +
((__t = ( senderName )) == null ? '' : __t) +
'</span>\n        <span class="sender-email">&lt;' +
((__t = ( senderEmail )) == null ? '' : __t) +
'&gt;</span>\n    </div>\n    <div class="message-meta">\n        <button type="button" class="btn-forward" title="Forward this email">Forward</button>\n        <span class="message-date">' +
((__t = ( date )) == null ? '' : __t) +
'</span>\n        <span class="message-toggle">\n            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>\n        </span>\n    </div>\n</div>\n<div class="message-recipients">\n    <span class="to-label">To:</span> <span class="to-addresses">' +
((__t = ( toAddresses )) == null ? '' : __t) +
'</span>\n    ';
 if(ccAddresses) { ;
__p += '\n        <br/><span class="cc-label">Cc:</span> <span class="cc-addresses">' +
((__t = ( ccAddresses )) == null ? '' : __t) +
'</span>\n    ';
 } ;
__p += '\n</div>\n<div class="message-body">\n    <!-- The body is rendered inside an iframe so hostile email CSS stays\n         sandboxed, stray <script> tags are inert, and all links get\n         <base target="_blank"> so they open in a new tab. The iframe is\n         auto-sized to its content height after the body is written. -->\n    <iframe class="message-iframe" frameborder="0" scrolling="no" style="width:100%; height:0; border:0;"></iframe>\n</div>\n';
 if(attachments && attachments.length > 0) { ;
__p += '\n<div class="message-attachments">\n    <!-- The content of .attachments-region is rendered by MessageView.renderAttachments()\n         using the shared mails attachment view (Pdf/Image/Default preview + download).\n         The shared view already renders its own "Attachments" header. -->\n    <div class="attachments-region"></div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

